import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../Layouts/DataTable';
import { EApiType, EDataTableType, EModuleType } from '../../data/Constants';
import { getProductConfiguration } from '../../store/states/DataMaintenanceSlice';
import { useApiError } from '../../hooks';

import type { IManagementProps } from '../../../types';

export const ProductConfiguration = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.ProductConfigurationKey);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.productConfiguration')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataTableType.ProductConfiguration}
        getDataList={getProductConfiguration}
        moduleType={EModuleType.Datamaintainance}
      />
    </>
  );
};
